import {
  DocumentType,
  PaymentFrequency,
  PaymentMethod,
  ArchiveFilterType,
} from "@src/__generated__/graphql";

export const documentTypeToFriendlyName: Record<DocumentType, string> = {
  BILL: "Bill",
  BUSINESS_VERIFICATION: "Business Verification",
  INVOICE: "Invoice",
  MSA: "MSA",
  ORDER_FORM: "Order Form",
  OTHER: "Other",
  RECEIPT: "Receipt",
  SOW: "SOW",
  UNKNOWN: "Unknown",
  DATA_VENDOR_QUESTIONNAIRE: "Data Vendor Questionnaire",
  SOC_2_TYPE_I_REPORT: "SOC 2 Type I Report",
  SOC_2_TYPE_II_REPORT: "SOC 2 Type II Report",
  VENDOR_SECURITY_QUESTIONNAIRE: "Vendor Security Questionnaire",
  W_9: "W-9",
  DPA: "Data Processing Agreement",
  AMENDMENT: "Amendment",
  NDA: "NDA",
  CERTIFICATE_OF_INSURANCE: "Certificate of Insurance",
  INFORMATION_SECURITY_POLICY: "Information Security Policy",
  BUSINESS_CONTINUITY_AND_DISASTER_RECOVERY:
    "Business Continuity and Disaster Recovery",
  ISO_27001: "ISO 27001",
  COMPLIANCE_POLICY: "Compliance Policy",
  FINANCIALS: "Financials",
  PENETRATION_TEST: "Penetration Test",
  THIRD_PARTY_RISK_MANAGEMENT_POLICY: "Third Party Risk Management Policy",
  SERVICING_POLICY: "Servicing Policy",
};

export const paymentFrequencyToFriendlyName: Record<PaymentFrequency, string> =
  {
    ONE_TIME: "One Time",
    ANNUALLY: "Annually",
    BIANNUALLY: "Biannually",
    BIWEEKLY: "Biweekly",
    MONTHLY: "Monthly",
    QUARTERLY: "Quarterly",
    WEEKLY: "Weekly",
    OTHER: "Other",
  };

export const paymentMethodToFriendlyName: Record<PaymentMethod, string> = {
  CREDIT_CARD: "Credit Card",
  DEBIT_CARD: "Debit Card",
  ACH: "ACH",
  CASH: "Cash",
  CHECK: "Check",
  WIRE: "Wire",
  OTHER: "Other",
  UNKNOWN: "Unknown",
  EFT: "Electronic Funds Transfer",
};

export const archiveFilterToFriendlyName: Record<ArchiveFilterType, string> = {
  ACTIVE: "Active",
  ARCHIVED: "Archived",
  ALL: "All",
  ACTION_REQUIRED: "Pending",
};
